module.exports = __webpack_public_path__ + "assets/img/WhatsApp-white.2aae2b3a.svg";